import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'includes' })
export class IncludesPipe implements PipeTransform {
    public transform<T>(list: T[], ...values: T[]): boolean {
        if (!list) return false;
        return list.some((item) => values.includes(item));
    }
}
